import { Center, Loader } from '@mantine/core';
import { LandingFrame, useLanding } from '../features/site/landing';
import { PartnersSection } from '../features/site/partners';
import { HomePage } from './HomePage';

/** `/`: strona startowa wklejona przez admina (PRD §10 pkt 37), a bez niej – jak dotąd lista edycji (US-104). */
export function StartPage() {
  const landing = useLanding();
  if (landing.isPending) {
    return (
      <Center py="xl">
        <Loader aria-label="Ładowanie" />
      </Center>
    );
  }
  // Lista edycji ma partnerów u siebie (PRD §10 pkt 38); pod stroną startową dokładamy ich tutaj.
  return landing.data?.available && landing.data.version ? (
    <>
      <LandingFrame version={landing.data.version} />
      <PartnersSection />
    </>
  ) : (
    <HomePage />
  );
}
